export default {
  ja:[
    "新着グッズ",
    "リクエスト",
    "アイテム",
    "キーワード検索",
    "現在、あなたの住んでいる国では入金が対応していません。\nリクエストをする方とアイテムを買う事は出来ますが、リクエストに応える、アイテムを売ることが出来ません。\n現在対応国拡大中なのでもう少しお待ちください！",
    "個人情報の認証が完了していないので入金が出来ません。\nリクエストをすることは出来ますが、リクエストに応える事が出来ません。\nProfileページから3つの認証を行ってね！",
    "個人情報の認証が完了していないので入金が出来ません。\nアイテムの購入は出来ますが、アイテムの販売は出来ません。\nProfileページから3つの認証を行ってね！",
  ],
  en: [
    "New Arrivals",
    "Requests",
    "Item Markets",
    "search",
    "Currently, payment is not supported in your country of residence. \nYou can buy items with those who make requests, but you cannot sell items that meet your requests. \nWe are currently expanding the list of supported countries, so please hold on!",
    "Unable to create deposit due to  unverified personal information. \ncYou can create a request, but not able to answer to any requests. \nPlease perform 3 certifications from the Profile page!",
    "Due to unverified personal information, unable to confirm deposit. \nYou are able to purchase items, however not to sell any items. \nPlease perform 3 certifications from the Profile page!",

  ]
}
